import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote } from 'lucide-react';
const testimonials = [{
  name: 'Paul Manudat',
  text: "NWBBA Lynnwood, this is one place we call a Home away from home! One of the main reasons is because of Master Joe. He has welcomed our family into this Dojang with open arms and has made us feel like family from the very first moment we entered the school. My son Anthony, has been training with Coach Brandon, Master Joe and Master Kevin and loves Taekwondo and the sparring team. He rarely every misses a class and is always excited to go. The variety of workouts you get will keep your heart pumping, wear you out and make you want more. This place is number one in my book. The changes in my son's general attitude & performance are significant & noticeable. Mrs. Maria is jet ski office and is a miracle worker, she handles most of if not all the paper work, registration, fundraising, billing. You got questions, she has Answers. Bottom line: This is a Great School to be educated. Come join the family, you won't regret it!"
}, {
  name: 'Ruchi Paul',
  text: "Our 11 year old son started training in Taekwondo at the Northwest Black Belt Academy (NWBBA) almost one year ago. We soon realized that there was a vast difference between Martial art clubs & pro-grade comprehensive martial arts education center like NWBBA. Master Joe and the team of instructors & assistants are serious professionals who are dedicated to developing competitive, well rounded and disciplined athletes of the future. They pay meticulous attention to detail on every student's individual performance and work closely with them to bring out their best. The support staff at NWBBA are caring, kind and helpful. The changes in my son's general attitude & performance are significant & noticeable. We highly recommend NWBBA to all aspiring martial artists!"
}, {
  name: 'Satori Seraier',
  text: 'Through NWBBA, I have gained several strengths, including schedule prioritization and a respectful nature. Including these, my physical strengths have extremely exceeded my original expectations of myself. Emotional intelligence, although unexpected, has also contributed to my performance at NWBBA. All in all, these points contribute at the friendly and productive atmosphere you are immediately surrounding in when entering the dojang.'
}, {
  name: 'Marianne Pedigan',
  text: 'My daughter has been taking Taekwondo for 6 years. She started at another school but just recently moved to NWBBA with Master Joe Whitworth and his outstanding team of instructors. In the short time we have been here, we have been impressed with the caliber of expert instruction our daughter has received. She is excited to learn taekwondo again. She was three weeks away from getting her black belt before we moved schools, but she insists that this was the best decision we have made. She is eager to earn her black belt from Master Joe. She has learned so much and loves it. I am grateful. Master Joe is a great teacher and a wonderful role model. I would recommend this school to anyone. They invest in every penny.'
}, {
  name: 'Eric Miller',
  text: 'NWBBA, is a great place for Taekwondo. Master Joe is an amazing role model and Instructors. It is a great place for kids and adults alike. The discipline and respect that is taught and practiced by the kids is exceptional. Both teachers and parents from school recognize and comment about how polite, courteous, and respectful my daughter is. She stays focused and on task daily and I believe it is from the tenants that are taught at NWBBA. We love the place and would not take our kids anywhere else. We would highly recommend anyone else.'
}, {
  name: 'Kristina Allen',
  text: 'NWBBA has become a home away from home for my family. My daughter is on the competition team, that Master Joe coaches and it has become such a big part of her life. Master Joe and the other instructors know how to motivate, connect, encourage and make our kids better athletes and better human beings. We are so fortunate to have found NWBBA in Lynnwood. Kudos to Master Joe for creating a great program and great environment for our kids!'
}];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
interface ProofSectionProps {
  testimonialIndex?: number; // Show a single specific testimonial (0-5)
}
export function ProofSection({
  testimonialIndex
}: ProofSectionProps) {
  // If testimonialIndex is provided, show only that testimonial
  // Otherwise show all testimonials (for ProofPage)
  const displayTestimonials = testimonialIndex !== undefined ? [testimonials[testimonialIndex]] : testimonials;
  const isSingleTestimonial = testimonialIndex !== undefined;
  return <section className="py-20 px-4 bg-[#1e3a8a]" data-id="element-79">
      <div className="max-w-6xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-82">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-83">
              {isSingleTestimonial ? 'What Parents Say' : 'Proof'}
            </h2>
            <div className="w-24 h-1 bg-[#dc2626] mx-auto rounded-full mb-6" data-id="element-84"></div>
            <p className="text-blue-100 text-lg max-w-2xl mx-auto" data-id="element-85">
              Real stories from real families who've experienced the NWBBA
              difference.
            </p>
          </motion.div>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className={`grid grid-cols-1 ${isSingleTestimonial ? 'max-w-2xl mx-auto' : 'md:grid-cols-2 lg:grid-cols-3'} gap-6`} data-id="element-86">
          {displayTestimonials.map((testimonial, idx) => <motion.div key={idx} variants={fadeIn} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20" data-id="element-87">
              <Quote className="w-10 h-10 text-[#dc2626] mb-6" data-id="element-88" />
              <p className="text-blue-50 leading-relaxed mb-6 text-base" data-id="element-89">
                {testimonial.text}
              </p>
              <div className="pt-6 border-t border-white/20" data-id="element-90">
                <p className="font-bold text-white text-lg" data-id="element-91">
                  {testimonial.name}
                </p>
                <p className="text-blue-200 text-sm mt-1" data-id="element-92">NWBBA Parent</p>
              </div>
            </motion.div>)}
        </motion.div>

        {isSingleTestimonial && <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12" data-id="element-93">
            <Link to="/proof" className="inline-block px-8 py-4 bg-white text-[#1e3a8a] text-lg font-bold rounded-lg shadow-lg hover:bg-gray-100 transition-colors" data-id="element-94">
              Read More Success Stories
            </Link>
          </motion.div>}
      </div>
    </section>;
}